import { IMessageIconProps } from "interfaces";

const MessageIcon = ({ className, onClick }: IMessageIconProps) => {
    return (
        <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} onClick={onClick}>
            <path d="M1.125 5.38C1.125 6.18 1.6865 6.877 2.4785 6.9935C3.022 7.0735 3.571 7.135 4.125 7.178V9.5L6.163 7.462C6.30121 7.32467 6.48673 7.24543 6.6815 7.2405C7.63221 7.21418 8.58052 7.13171 9.5215 6.9935C10.3135 6.877 10.875 6.1805 10.875 5.3795V2.3705C10.875 1.5695 10.3135 0.873001 9.5215 0.756501C8.35548 0.585358 7.17851 0.49963 6 0.500001C4.804 0.500001 3.628 0.587501 2.4785 0.756501C1.6865 0.873001 1.125 1.57 1.125 2.3705V5.3795V5.38Z" stroke="" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default MessageIcon;